// Public browser pixel only. CAPI credentials belong exclusively in Impul.
export const META_PIXEL_ID = "28660680160264368";

type MetaPixel = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};

type PixelWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
  __storePixelPageViews?: Record<string, boolean>;
};

export function initializeMetaPixel(): void {
  if (typeof window === "undefined") return;
  const pixelWindow = window as PixelWindow;
  const pageViews = pixelWindow.__storePixelPageViews ||= {};
  if (pageViews[META_PIXEL_ID]) return;

  if (!pixelWindow.fbq) {
    const fbq: MetaPixel = function (...args: unknown[]) {
      if (fbq.callMethod) fbq.callMethod(...args);
      else fbq.queue.push(args);
    } as MetaPixel;
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    pixelWindow.fbq = fbq;
    if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }

  // One initialization and PageView even if React mounts the effect again.
  pageViews[META_PIXEL_ID] = true;
  pixelWindow.fbq("set", "autoConfig", false, META_PIXEL_ID);
  pixelWindow.fbq("init", META_PIXEL_ID);
  pixelWindow.fbq("trackSingle", META_PIXEL_ID, "PageView");
  // Impul owns InitiateCheckout and approved-order Purchase events, with
  // its native browser/CAPI deduplication. Offer scrolling sends no event.
}
